module.exports = __webpack_public_path__ + "img/logo_europesengage.845740fd.jpg";